import {useContext, useMemo, useState} from 'react';
import {Redirect, Toast} from '@shopify/app-bridge/actions';
import {createApp} from "@shopify/app-bridge";
import {API_KEY, AppBridgeContext} from "../App";
import {cancelBillingAPI, checkBillingStatusAPI, createBillingAPI} from "../api/axiosRequests";
import {SHOPIFY_INSTALL_API} from "../constants/apiUrls";

export function useBilling(host: string, shop: string | null) {
    const app = useContext(AppBridgeContext);
    const appBridge = useMemo(() => createApp({apiKey: API_KEY, host, forceRedirect: true}), [host]);

    const [checkingBilling, setCheckingBilling] = useState(true);
    const [billingActive, setBillingActive] = useState(false);
    const [isFreePlan, setIsFreePlan] = useState(true);

    const showToast = (message: string) => {
        if (!app) return;
        Toast.create(app, {message, duration: 3000}).dispatch(Toast.Action.SHOW);
    };

    const checkBilling = async () => {
        setCheckingBilling(true);
        try {
            const res = await checkBillingStatusAPI(shop);
            setIsFreePlan(res.data.plan === 'free');
            setBillingActive(res.data.status === 'active');
        } catch (r: any) {
            console.log('error', r);
            if (r.response && r.response.status === 402) {
                setBillingActive(false);
            } else {
                showToast('Failed to check billing status');
            }
        } finally {
            setCheckingBilling(false);
        }
    };

    const createBilling = async () => {
        const billingRes = await createBillingAPI(shop, host);
        Redirect.create(appBridge).dispatch(Redirect.Action.REMOTE, billingRes.data.confirmationUrl);
    }

    const handleCancelSubscription = async () => {
        if (!window.confirm('Are you sure you want to cancel your subscription?')) return;
        try {
            await cancelBillingAPI(shop);
            showToast('Subscription cancelled');
            setBillingActive(false);
            await checkBilling();
        } catch {
            showToast('Failed to cancel subscription');
        }
    };

    return {
        checkingBilling,
        billingActive,
        showToast,
        checkBilling,
        createBilling,
        isFreePlan,
        handleCancelSubscription,
        app,
    };
}
